import { render } from "./HSPagination.vue?vue&type=template&id=15def144&scoped=true"
import script from "./HSPagination.vue?vue&type=script&lang=js"
export * from "./HSPagination.vue?vue&type=script&lang=js"

import "./HSPagination.vue?vue&type=style&index=0&id=15def144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15def144"]])

export default __exports__